import React from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import classname from 'classnames';
import UserDatabases from '@Services/UserDatabases';
import { Dropdown } from '@els/els-react--dropdown';
import HoverTooltip from '@Components/HoverTooltip';

import './QueryOptionsDropdown.scss';

function QueryOptionsDropdown(props) {
  const { queryOptionsType, handleSelectOperation, type, node } = props;
  const operationEntries = Object.entries(queryOptionsType?.operations || {});

  const options =
    type === 'advanced'
      ? queryOptionsType?.databases?.map((item) => ({
          id: `query-options-dropdown-${kebabCase(item === null ? 'Any Databases' : UserDatabases.getDbName?.(item))}`,
          key: item === null ? -1 : item,
          label: item === null ? 'Any Databases' : UserDatabases.getDbName?.(item),
        })) || []
      : operationEntries.map(([key, value]) => ({
          id: `query-options-dropdown-${key}`,
          key,
          label: value,
        }));

  let title;
  /** Reusing this for Advanced type as well , but the way we show title is different so condition based title rendering */
  if (type === 'advanced') {
    title =
      queryOptionsType?.databases &&
      queryOptionsType?.data &&
      queryOptionsType?.data?.databaseId !== null &&
      queryOptionsType?.data?.databaseId !== -1
        ? UserDatabases.getDbName?.(queryOptionsType?.data?.databaseId) || 'Any Databases'
        : 'Any Databases';
  } else {
    title =
      queryOptionsType?.operations && queryOptionsType?.data?.operation
        ? queryOptionsType?.operations?.[queryOptionsType?.data?.operation]
        : queryOptionsType?.operations?.[queryOptionsType?.data?.defaultBoundOperator];
  }
  const dropdownName = type === 'advanced' ? 'Database options' : 'Truncation operators';

  return (
    <div
      className={classname('ql__prop__form--dropdown', {
        'ql__prop__header--dropdown_numeric': node?.canExist,
      })}>
      <HoverTooltip theme="simple" tooltip={dropdownName} tooltipPlace="bottom">
        <Dropdown
          id="query-options-dropdown-main"
          label={title}
          name="queryOptionsDropdown"
          options={options}
          buttonProps={{
            type: 'link',
            'aria-label': `${dropdownName}, current value: ${title}`,
          }}
          onChange={(eachKey) => {
            handleSelectOperation(eachKey.key);
          }}
        />
      </HoverTooltip>
    </div>
  );
}

QueryOptionsDropdown.propTypes = {
  queryOptionsType: PropTypes.object,
  handleSelectOperation: PropTypes.func,
  type: PropTypes.string,
  node: PropTypes.object,
};
export default QueryOptionsDropdown;
